import { useLocation } from 'react-router-dom';
import { getLocationForDataTracking } from 'utils/mixpanel';

const useMixpanelEvent = (): string => {
  const location = useLocation();
  return getLocationForDataTracking(location.pathname);
};

export default useMixpanelEvent;
